import { useState, useEffect } from "react";
import Menu from "../components/Menu";
import { motion } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";
import { Lightbox } from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Captions from "yet-another-react-lightbox/plugins/captions";
import "yet-another-react-lightbox/plugins/captions.css";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import { Helmet } from "react-helmet";

export default function Gallery() {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);
  const [photos, setPhotos] = useState([]);
  const API_BASE = "https://tomaszfotograf.pl";

  useEffect(() => {
    const fetchPhotos = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/photosdb`);
        if (!res) throw new Error("Błąd pobierania danych z API");

        const data = await res.json();
        //console.log("DATA: ", data);
        const prepared = data.map((item) => ({
          ...item,
          fullSrc: `${API_BASE}/files/${item.fileoriginal}`,
          miniSrc: `${API_BASE}/files/mini/${item.fileoriginal}`,
        }));

        prepared.sort((a, b) => {
          const descA = a.description ? a.description.toLowerCase() : "";
          const descB = b.description ? b.description.toLowerCase() : "";
          if (!descA && !descB) return 0;
          if (!descA) return 1;
          if (!descB) return -1;
          return descA.localeCompare(descB);
        });

        setPhotos(prepared);
      } catch (err) {
        console.error("Błąd:", err);
      }
    };

    fetchPhotos();
  }, []);

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@id":
              "https://tomaszfotograf.pl/galeria-wnetrz-i-nieruchomosci#gallery",
            "@type": "ImageGallery",
            name: "Galeria fotografii wnętrz i nieruchomości - Tomasz Fotograf",
            description:
              "Portfolio profesjonalnych sesji fotograficznych nieruchomości, wnętrz komercyjnych oraz architektury. Zobacz realizacje dla projektantów, hoteli i rynku nieruchomości premium.",
            url: "https://tomaszfotograf.pl/galeria-wnetrz-i-nieruchomosci",
            author: {
              "@type": "ProfessionalService",
              name: "Tomasz Fotograf",
              url: "https://tomaszfotograf.pl",
            },
            provider: {
              "@type": "ProfessionalService",
              name: "Tomasz Fotograf",
              image: "https://tomaszfotograf.pl/logo.png", // Dodaj ścieżkę do swojego logo, jeśli masz
              priceRange: "$$",
              address: {
                "@type": "PostalAddress",
                addressLocality: "Warszawa",
                addressCountry: "PL",
              },
            },
            mainEntity: {
              "@type": "Service",
              name: "Fotografia i wideo nieruchomości",
              areaServed: {
                "@type": "AdministrativeArea",
                name: "Warszawa i okolice",
              },
              hasOfferCatalog: {
                "@type": "OfferCatalog",
                name: "Portfolio usług fotograficznych",
                itemListElement: [
                  {
                    "@type": "Offer",
                    itemOffered: {
                      "@type": "Service",
                      name: "Sesje zdjęciowe wnętrz i architektury",
                      description:
                        "Profesjonalne zdjęcia dla architektów, hoteli (HoReCa) oraz na potrzeby sprzedaży nieruchomości premium.",
                    },
                  },
                  {
                    "@type": "Offer",
                    itemOffered: {
                      "@type": "Service",
                      name: "Produkcja wideo i ujęcia z drona",
                      description:
                        "Dynamiczne prezentacje wideo nieruchomości oraz ujęcia z powietrza podkreślające lokalizację.",
                    },
                  },
                  {
                    "@type": "Offer",
                    itemOffered: {
                      "@type": "Service",
                      name: "Virtual Staging i retusz premium",
                      description:
                        "Zaawansowana edycja zdjęć i komputerowe przygotowanie wnętrz do sprzedaży.",
                    },
                  },
                ],
              },
            },
          })}
        </script>
      </Helmet>
      <Menu />
      <div className="fullpage1">
        <section className="section section-dark section-gallery images-row">
          {photos.map(
            ({ miniSrc, dateTaken, fileoriginal }, realIndex) =>
              realIndex < 250 && (
                <motion.div
                  key={`${miniSrc}-${realIndex}`}
                  style={{
                    textAlign: "center",
                    flex: "0 0 20.00%",
                    boxSizing: "border-box",
                    padding: "0px",
                  }}
                  initial={{ opacity: 0, y: 50, scale: 0.9 }}
                  animate={{ opacity: 1, y: 0, scale: 1 }}
                  transition={{
                    delay: 0.3 + realIndex * 0.15,
                    duration: 0.7,
                    ease: "easeOut",
                  }}
                >
                  <img
                    src={miniSrc}
                    alt={`miniatura-${realIndex}`}
                    style={{
                      width: "100%",
                      maxWidth: 500,
                      maxHeight: "auto",
                      objectFit: "cover",
                      cursor: "pointer",
                      padding: 0,
                      background: "#fff",
                      border: "2px solid #fff",
                      borderRadius: 0,
                      boxShadow: "0 22px 8px rgba(0,0,0,0.1)",
                      transition: "transform 0.2s",
                    }}
                    onClick={() => {
                      setIndex(realIndex);
                      setOpen(true);
                    }}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.transform = "scale(1.10)")
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.transform = "scale(1.0)")
                    }
                  />
                </motion.div>
              )
          )}
        </section>
      </div>
      {/*
      <Lightbox
        open={open}
        close={() => setOpen(false)}
        index={index}
        slides={photos.map((p) => ({
          src: p.fullSrc,
        }))}
        plugins={[Captions, Slideshow, Zoom]}
        zoom={{
          maxZoomPixelRatio: 3,
          zoomInMultiplier: 2,
          doubleTapDelay: 300,
          scrollToZoom: true,
        }}
        slideshow={{ autoplay: false, delay: 4000 }}
      />
      */}
      <Lightbox
        open={open}
        close={() => setOpen(false)}
        index={index}
        slides={photos.map((p) => ({ src: p.fullSrc }))}
        plugins={[Captions, Slideshow, Zoom]}
        render={{
          iconPrev: () => (
            <ArrowBackIos style={{ fontSize: 40, color: "#fff" }} />
          ),
          iconNext: () => (
            <ArrowForwardIos style={{ fontSize: 40, color: "#fff" }} />
          ),
        }}
      />
    </>
  );
}
